import AxiosService from '@/services/AxiosServices'

export default {
  /**
   * Get list of CategoriesScenario
   *
   * @param perPage => limit
   * @param page => item by page
   * @param order => obj with index and ASC or DESC
   * @param search => research
   * @returns {*}
   */
  getCategoriesScenario(perPage, page, order, search) {
    let url = 'admin/categories/scenarios'
    if(perPage)
      url += '?_limit=' + perPage + '&_page=' + page
    if(order !== null)
      url += '&_index=' + order.index + '&_order=' + order.order
    if(search !== null)
      url += '&_search=' + search

    return AxiosService.callApi().get(url)
  },
  /**
   * Get CategoryScenario by id
   *
   * @param id
   * @returns {*}
   */
  getCategoryScenario(id) {
    return AxiosService.callApi().get('/admin/categories/scenarios/' + id)
  },
  /**
   * Create CategoryScenario
   *
   * @param data
   * @returns {*}
   */
  create(data) {
    return AxiosService.callApi().post('/admin/categories/scenarios', data)
  },
  /**
   * Edit CategoryScenario
   *
   * @param id
   * @param data
   * @returns {*}
   */
  edit(id, data) {
    return AxiosService.callApi().put('/admin/categories/scenarios/' + id, data)
  },
  /**
   * Delete CategoryScenario
   *
   * @param id
   * @returns {*}
   */
  delete(id) {
    return AxiosService.callApi().delete('/admin/categories/scenarios/' + id)
  }
}
